import { SignInForm } from './sign-in.form';

export const SignIn = () => {
    return <SignInForm />;
};
